import { render, staticRenderFns } from "./Finalize.vue?vue&type=template&id=b655f0f6&scoped=true&"
import script from "./Finalize.vue?vue&type=script&lang=js&"
export * from "./Finalize.vue?vue&type=script&lang=js&"
import style0 from "./Finalize.vue?vue&type=style&index=0&id=b655f0f6&prod&lang=scss&"
import style1 from "./Finalize.vue?vue&type=style&index=1&id=b655f0f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b655f0f6",
  null
  
)

export default component.exports